import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('keywordListTargeting', {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      selectedOptions: '<'
    },
    template: require("../templates/keywordListTargeting.html"),
    controllerAs: '$keywordListTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.allowlistOptions();
    }
  });
